module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_03 (2).e5591d08.png";